/**
 * Chance de governador no cartão da UF (§8 de 14/10, noite, C03 e K06; P-05; P-30 item 7): a mesma faixa da chance do
 * presidente (`ProbabilityStrip`), com os números da UF no detalhe da chance (`governor[uf]`). Pede o detalhe enquanto o
 * bloco está na tela. Não aparece: com `features.probability` desligada, sem a UF no detalhe (a trava por ciclo do motor
 * tira e põe a UF: "sem chance agora"), com a UF já definida (vale a decisão, não a estimativa) e na TV. Governador
 * nunca tem a chamada "mais de 99" (P-05): a faixa fica entre 1 e 99.
 */
import { useEffect } from 'preact/hooks';
import type { UfCode } from '../contracts/base';
import { ProbabilityStrip } from '../features/probability/ProbabilityStrip';
import { wantProbabilityDetail } from '../state/actions';
import { useConfig, useLayout, useView } from '../state/hooks';
import { probabilityDetail } from '../state/store';

export function GovernorChance({ uf }: { uf: UfCode }) {
  const cfg = useConfig();
  const view = useView();
  const { mode } = useLayout();
  const on = cfg.features.probability && mode !== 'tv';
  useEffect(() => {
    if (!on) return;
    wantProbabilityDetail(true);
    return () => wantProbabilityDetail(false);
  }, [on]);
  const race = view?.governor[uf];
  const proj = probabilityDetail.value?.governor?.[uf];
  if (!on || !race || !proj || race.mathDecision || race.tseResult) return null;
  return <ProbabilityStrip win={proj.win_prob} votes={proj.final_votes ?? null} candidates={race.candidates} />;
}
